import React from 'react';
import { Card } from 'react-bootstrap';
import  { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap';
import { Modal, Table } from 'react-bootstrap';
import { useState }  from 'react';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useForm, Controller } from 'react-hook-form'
import { updateSelezioneStakeholders } from '../reduxStore/questCorrenteSlice.js'
import { FcCancel } from "react-icons/fc";
import { FcOk } from "react-icons/fc";


const SelezioneStakeholder = () => {
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
  const [modalShow, setModalShow] = useState(false);

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }
//  FINE GESTIONE Modal
// ----------------------------------------------------------

// ----------------------------------------------------------
  // estraggo array stakeholders da questionarioCorrente:
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  // const stakeholdersArray = questionarioCorrente.stakeholders
  const excludedIds = ['AZ', 'CT'];
  const stakeholdersArray = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));
  
  console.log(stakeholdersArray)
// ----------------------------------------------------------


//  INIZIO GESTIONE PER react-hook-form
  const dispatch = useDispatch();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      stakeholders: stakeholdersArray.map(({ id, nome, alias, enabled }) => ({ id, nome, alias, enabled }))
    }
  });

  const onSubmit = (data) => {
    console.log(data);
    const updatedValues = {
        questionarioUuid: questionarioCorrente.questionarioUuid, 
        stakeholdersArray: data
    }
    console.log('Selezione Stakeholders - updatedValues: ', updatedValues)
    
    dispatch(updateSelezioneStakeholders(updatedValues)) // < da implementare!!
    setModalShow(false)
  };
//  FINE GESTIONE PER react-hook-form


return (
  <Card className="text-left">
    <Card.Body className="p-5">
      <h1 className="text-center">
        <strong>Selezione aziendale degli stakeholders comuni rilevanti</strong>
      </h1>

      <hr />
  <Button variant="primary" onClick={handleOpenModal}>
    Modifica selezione stakeholders
  </Button>
  <hr />
  <Table className="fs-10 mt-3">
        <thead>
          <tr className="align-left white-space-nowrap" >
            <th key="classe" className="fs-10 text-900">
              codice
            </th>
            <th key="enabled" className="fs-10 text-900">
            </th>
            <th key="key" className="fs-10 text-900">
              nome
            </th>
            <th key="descrizione" className="fs-10 text-900">
              alias
            </th>
          </tr>
        </thead>
        <tbody>
          {stakeholdersArray.map((stakeholder) => (
            <tr
              key={stakeholder.id}
              className="align-middle white-space-nowrap"
            >
              <td key="classe" className="fs-10 text-900">
                {stakeholder.id}
              </td>
              <td key="enabled" className="fs-10 text-900">
                {(stakeholder.enabled)?<FcOk />:<FcCancel />}
              </td>
              <td key="key" className="fs-10 text-900">
                {stakeholder.nome}
              </td>
              <td key="alias" className="fs-10 text-900">
                {stakeholder.alias}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <hr />
      <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Seleziona Stakeholders</Modal.Title>
          <FalconCloseButton onClick={handleCloseModal}/>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Table className="fs-10 mt-3">
              <thead>
                <tr className="align-left white-space-nowrap" >
                  <th key="classe" className="fs-10 text-900">
                    codice
                  </th>
                  <th key="key" className="fs-10 text-900">
                    nome
                  </th>
                  <th key="descrizione" className="fs-10 text-900">
                    alias
                  </th>
                  <th key="enabled" className="fs-10 text-900">
                  </th>
                </tr>
              </thead>
              <tbody>
                {stakeholdersArray.map((stakeholder, index) => (
                  <tr key={stakeholder.id} className="align-middle white-space-nowrap">
                    <td className="fs-10 text-900">{stakeholder.id}</td>
                    <td className="fs-10 text-900">{stakeholder.nome}</td>
                    <td className="fs-10 text-900">
                    <Controller
                      name={`stakeholders[${index}].alias`}
                      control={control}
                      render={({ field }) => (
                        <input
                          type="text"
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      )}
                    />
                    </td>
                    <td>
                      <Controller
                        name={`stakeholders[${index}].enabled`}
                        control={control}
                        render={({ field }) => (
                          <input 
                            type="checkbox" 
                            {...field} 
                           checked={field.value} 
                          />
                        )}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
            <Button variant="primary" type="submit">Invia</Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Card.Body>
  </Card>
);

};

export default SelezioneStakeholder;
